import { ControlValueAccessor } from '@angular/forms'

export class BaseControlValueAccessor<T> implements ControlValueAccessor {
  disabled = false
  value: T
  onChange(newVal: T) {}
  onTouched(_?: any) {}

  //write to DOM
  writeValue(obj: T): void {
    this.value = obj
  }
  //save callback for later call onChange()
  registerOnChange(fn: any): void {
    this.onChange = fn
  }
  //save callback for later call onTouched()
  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
}
